import { useProgress } from '@react-three/drei';
import React, { useEffect, useState } from "react";

export default function Loader() {
    const { progress } = useProgress();
    const [maxProgress, setMaxProgress] = useState(0);

    useEffect(() => {
        if (progress > maxProgress) {
            setMaxProgress(progress);
        }
    }, [progress]);

    const roundedProgress = Math.round(maxProgress);

    return (
        <div className="w-screen h-[100dvh] flex flex-col justify-end items-start bg-second transition-all ease-in-out duration-150">
            <div className="w-screen px-6 pb-6 md:px-10 md:pb-10 flex flex-col justify-end items-start transition-all ease-in-out duration-150">
                <p className="font-['sm-avenir'] text-sm md:text-base text-first m-0 opacity-0 animate-[reveal_1.5s_cubic-bezier(0.77,_0,_0.175,_1)_0.2s_forwards]">
                    Chargement de la visite virtuelle...
                </p>
                <p className="font-['md-avenir'] text-8xl md:text-9xl m-0 p-0 leading-none text-first opacity-0 animate-[reveal_1.5s_cubic-bezier(0.77,_0,_0.175,_1)_0s_forwards]">
                    {roundedProgress}%
                </p>
            </div>
            <div className="absolute bottom-0 left-0 w-screen h-[10px]">
                <div 
                    className="h-full bg-first transition-all ease-in-out duration-[800ms] opacity-0 animate-[display_0.8s_cubic-bezier(0.77,_0,_0.175,_1)_0s_forwards]"
                    style={{ width: `${roundedProgress}%` }}
                ></div>
            </div>
        </div>
    );
}